// extracted by mini-css-extract-plugin
module.exports = {"flip":"Arrow_flip__1zLls"};